import React, { forwardRef } from "react";
import { ReactSVG } from "react-svg";

const CancelButton = forwardRef(({
  className,
  title,
  icon,
  disabled,
  onClick,
  ...props
}, ref) => (
  <button
    ref={ref}
    className={`${className} common-cancel-button`}
    disabled={disabled}
    onClick={onClick}
    {...props}
  >
    <span className="content">
      {title}
      {icon ? <ReactSVG className="icon" src={icon} /> : null}
    </span>
  </button>
));

export default CancelButton;
